import { render, staticRenderFns } from "./ArticleInfoPaywallDisableCountdown.vue?vue&type=template&id=ecc817a2&scoped=true"
import script from "./ArticleInfoPaywallDisableCountdown.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoPaywallDisableCountdown.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoPaywallDisableCountdown.vue?vue&type=style&index=0&id=ecc817a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc817a2",
  null
  
)

export default component.exports